import { render, staticRenderFns } from "./UiBtnClose.vue?vue&type=template&id=58889780&scoped=true"
import script from "./UiBtnClose.vue?vue&type=script&lang=js"
export * from "./UiBtnClose.vue?vue&type=script&lang=js"
import style0 from "./UiBtnClose.vue?vue&type=style&index=0&id=58889780&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58889780",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/moderlab/moderclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58889780')) {
      api.createRecord('58889780', component.options)
    } else {
      api.reload('58889780', component.options)
    }
    module.hot.accept("./UiBtnClose.vue?vue&type=template&id=58889780&scoped=true", function () {
      api.rerender('58889780', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/UI/UiBtnClose.vue"
export default component.exports